import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'ol';
const idGen = new IDGenerator('wm_breadcrumb');

register('wm-breadcrumb', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmListenProperty="dataset" wmBreadcrumb #${counter}="wmBreadcrumb" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
